import { Location } from '@angular/common';
import { Injectable, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentStore } from '@ngrx/component-store';
import { AccountService, CustomFirestoreService, FirebaseStorageService, StripePaymentSelectionService } from '@spout/global-web/data-access';
import { APP_ROUTES } from '@spout/global-web/models';
import 'firebase/functions';
import { combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { User } from '@firebase/auth';
@Injectable({
  providedIn: 'root'
})
export class ServiceLocator {
	constructor(
		private sptFirebase: CustomFirestoreService,
		private route: ActivatedRoute,
		private router: Router,
		private locationService: Location,
		private zone: NgZone,
	//	private LoginService: LoginService,
		private AccountService: AccountService,
		private StripeService: StripePaymentSelectionService,
		private FirebaseService: FirebaseStorageService
	) {
	}
}